import { html, css, svg, TemplateResult, CSSResultGroup } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'
import { BaseComponent } from './base-component.js'

@customElement('il-dropdown-trigger-button')
export default class DropdownTriggerButtonComponent extends BaseComponent {
  @property({ type: Boolean }) disabled: boolean = false
  @property({ type: Number }) count: number = 0

  @property({ type: Object }) onClick?: () => void

  override render(): TemplateResult {
    return html`
      <div
        class=${classMap({
          'il-dropdown-trigger-button': true,
          'il-dropdown-trigger-button--with-count': true,
        })}
        data-testid="iliad-dropdown-trigger-button"
      >
        <il-button
          variant="secondary"
          small
          color="primary"
          ?disabled=${this.disabled}
          .onClick=${() => this.onClick?.()}
          data-testid="iliad-dropdown-trigger-button"
        >
          <div class="il-dropdown-trigger-button__count-container">
            <span class="il-dropdown-trigger-button__count" data-testid="iliad-dropdown-trigger-button-count">${this.count}</span>
          </div>

          ${this._caratIcon}
        </il-button>
      </div>
    `
  }

  private _caratIcon: TemplateResult = svg`
    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 7.28114L10 14.3L17 7.28113L15.7055 6L10 11.7209L4.29449 6L3 7.28114Z" />
    </svg>
  `

  static override styles: CSSResultGroup = [
    BaseComponent.styles,
    css`
    .il-dropdown-trigger-button {
      display: inline-block;
    }

    .il-dropdown-trigger-button il-button::part(button) {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }

    .il-dropdown-trigger-button__count-container {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      width: 0;
      opacity: 0;
      overflow: hidden;

      transition: opacity 0.2s ease;
    }

    .il-dropdown-trigger-button--with-count .il-dropdown-trigger-button__count-container {
      width: auto;
      opacity: 1;
    }

    .il-dropdown-trigger-button__count {
      font-size: var(--il-font-size-16);
      font-weight: var(--il-font-weight-xbold);
      line-height: var(--il-font-line-height-125);
      letter-spacing: var(--il-font-letter-spacing-2);
      color: var(--il-color-accent-300);

      width: 20px;
      text-align: center;
    }

    .il-dropdown-trigger-button svg {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
    }
  `]
}
